module.exports = __webpack_public_path__ + "static/media/eth-usdc.36434901.svg";